import { PreviewVisit } from '../../../visit-daily-overview-diagram';
import { AvailableSlotsGrid } from '../AvailableSlotsGrid';
import { useReservationTimeSlots } from './reservation-time-slots.hooks';

type ReservationTimeSlotsProps = {
  serviceIds: string | undefined;
  previewVisit: PreviewVisit | undefined;
  setPreviewVisit: React.Dispatch<React.SetStateAction<PreviewVisit | undefined>>;
};

export const ReservationTimeSlots = ({
  serviceIds,
  previewVisit,
  setPreviewVisit,
}: ReservationTimeSlotsProps) => {
  const { handleSlotClick, date, slots, reason } = useReservationTimeSlots(
    setPreviewVisit,
    serviceIds,
  );

  if (!date || !serviceIds) {
    return null;
  }

  return (
    <AvailableSlotsGrid
      availableSlots={slots}
      selectedDate={date}
      previewStartTime={previewVisit?.startTime}
      onSlotClick={handleSlotClick}
      hasServiceSelected={!!serviceIds}
      noSlotsReason={reason}
    />
  );
};
